module.exports = __webpack_public_path__ + "media/packs/images/filled-arrow-down-5b05fcde76a7278fda5c9df063b79de2.svg";